<template>
  <v-app-bar color="primary" dark>
    <div class="navbar">
      <router-link class="navbar__logo" :to="{ name: 'menu.index' }">
        <img src="/images/geodis.png" alt="Geodis Logo">
      </router-link>

      <v-menu min-width="100" v-if="User.email">
        <template v-slot:activator="{ on, attrs }">
          <v-avatar
            class="outlined"
            size="40"
            v-bind="attrs"
            v-on="on"
          >
            <span class="white--text">{{ shortName }}</span>
          </v-avatar>
        </template>

        <v-card>
          <v-list-item-content class="justify-center">
            <div class="mx-auto text-center">
              <h3 class="px-3" v-if="fullName">{{ fullName }}</h3>
              <p class="caption mb-0 px-3">{{ User.email }}</p>

              <template v-if="IsAdmin">
                <v-divider class="my-3"></v-divider>
                <a href="/admin" target="_blank">
                  <v-btn depressed rounded text>Manage</v-btn>
                </a>
              </template>

              <v-divider class="my-3"></v-divider>
              <v-btn
                @click="logout"
                v-translate="'general.logout'"
                depressed
                rounded
                text
              >Logout</v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </div>
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'app-navbar',
  computed: {
    ...mapState([
      'User',
      'IsAdmin',
    ]),
    fullName() {
      if (!this.User.firstName && !this.User.lastName) return '';
      return `${this.User.firstName} ${this.User.lastName}`;
    },
    shortName() {
      let letters = '';
      const names = this.User.email.replace(/@.*/g, '')
        .split('.')
        .filter(Boolean);

      if (names.length > 1) {
        letters = names.map(name => name[0].toUpperCase())
          .join('');
      } else {
        letters = names[0].slice(0, 2)
          .toUpperCase();
      }

      return letters;
    },
  },
  methods: {
    async logout() {
      // await Auth.logout();
      this.$store.commit('LOGOUT');

      if (process.env.NODE_ENV === 'production') {
        const url = window.location.origin;
        window.location.href = `${url}/api/auth/initiatesinglelogout?returnUrl=${url}/logout`;
      } else {
        this.$router.push({ name: 'login' });
      }
    },
  },
};
</script>
